// Journal de visite (T-242c) — logique pure : identifiant d'entrée, file de reprise hors ligne, fusion serveur/file.
// AJOUT SEUL (zone mobile gelée N°861) : aucune fonction ici ne modifie ni ne supprime une entrée déjà envoyée.

export const MAX_TEXTE = 4000;

export function nouvelIdEntree() {
  const alea = typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID().replace(/-/g, "")
    : `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 14)}`;
  return `jrn-${alea}`.slice(0, 64);
}

export function cleFile(dossierId) {
  return `dal-journal-file:${dossierId}`;
}

export function lireFile(dossierId) {
  try {
    const brut = localStorage.getItem(cleFile(dossierId));
    const liste = brut ? JSON.parse(brut) : [];
    return Array.isArray(liste) ? liste.filter(e => e && e.entry_id && e.texte) : [];
  } catch {
    return [];
  }
}

export function ecrireFile(dossierId, file) {
  try {
    if (!file.length) localStorage.removeItem(cleFile(dossierId));
    else localStorage.setItem(cleFile(dossierId), JSON.stringify(file));
    return true;
  } catch {
    return false;
  }
}

export function fabriquerEntree(texte, type = "note", maintenant = new Date()) {
  const propre = String(texte || "").trim().slice(0, MAX_TEXTE);
  if (!propre) return null;
  return { entry_id: nouvelIdEntree(), type: type === "dictee" ? "dictee" : "note", texte: propre,
           horodatage_client: maintenant.toISOString() };
}

// Les entrées du serveur d'abord (ordre d'arrivée), puis celles encore en file qu'il ne connaît pas.
export function fusionner(serveur, file) {
  const connus = new Set((serveur || []).map(e => e.id));
  const attente = (file || []).filter(e => !connus.has(e.entry_id))
    .map(e => ({ id: e.entry_id, type: e.type, texte: e.texte, horodatage: null, horodatage_client: e.horodatage_client, enAttente: true }));
  return [...(serveur || []), ...attente];
}

// Envoie UNE entrée. Retourne "ok" | "reessayer" (réseau, 5xx, 401) | "refuse" (4xx définitif : on ne boucle pas).
export async function envoyerEntree({ api, dossierId, entree, entetes }) {
  try {
    const res = await fetch(`${api}/api/dal/save-mobile/${dossierId}/journal`, {
      method: "POST", headers: { "Content-Type": "application/json", ...entetes }, body: JSON.stringify(entree),
    });
    if (res.ok) return "ok";
    if (res.status === 401 || res.status >= 500 || res.status === 429) return "reessayer";
    return "refuse";
  } catch {
    return "reessayer";
  }
}
